import BaseModel from '../BaseModel';

export default class InterviewPreset extends BaseModel {
  static entity = 'interviewPresets';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      title: this.string(null).nullable(),
      summary: this.string(null).nullable(),
      description: this.string(null).nullable(),
      duration: this.number(null).nullable(),
      type: this.string(null).nullable(),
      interviewers: this.attr([]),
      recommended: this.boolean(false),
      counts: this.attr({}),
    };
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get('interviews/presets');
      },
    },
  }
}
